import JournalDefault from "../components/Journal/Default";
import JournalVolumes from "../components/Journal/JournalVolumes";

const routes = [
  {
    path: "/journal",
    component: JournalDefault,
    redirect: "/journal/volumes",
    meta: {
      requiresAuth: true,
      section: "Journal",
    },
    children: [
      {
        path: "volumes",
        name: "journalVolumes",
        component: JournalVolumes,
        meta: {
          requiresAuth: true,
          description: "Publishing: Journal volumes",
        },
      },
    ],
  },
];

export default routes;
